import React, { useEffect, useState } from 'react';
import Loaders from '../Loaders';
import HeaderTop from '../HeaderTop';
import Menus from '../Menus';
import Footers from '../Footers';
import '../../../libs/css/bootstrap.min3.3.7.css';
import '../../../libs/css/sweetalert2.min.css';
import { API_ROUTES } from '../../../utils/constants';
import HourlyRevenueFilter from './HourlyRevenueFilter';
import HourlyRevenueCharts from './HourlyRevenueCharts';

const todayYMD = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export default function HourlyRevenueReport(props) {
    const { objectToFormData, isAuthExpired } = props;

    useEffect(() => { document.title = 'Hourly Revenue Report | Forthsoft'; }, []);

    const [isLoading, setIsLoading] = useState(false);
    const [isFade, setIsFade] = useState(false);
    const [hasFetchedOnce, setHasFetchedOnce] = useState(false);
    const [error, setError] = useState(null);
    const [hourlyRevenue, setHourlyRevenue] = useState([]);
    const [hourlyCount, setHourlyCount] = useState([]);
    const [selectedDateStr, setSelectedDateStr] = useState(todayYMD());

    const fetchData = async ({ date, network_id, serviceId }) => {
        const userData = JSON.parse(localStorage.getItem('userDataFs'));
        // cp_id is always the logged-in user's own id, sourced from the authenticated
        // session — never user-editable and never accepted from the URL.
        const cpId = userData?.responseDetails?.user_id || localStorage.getItem('user_id');

        if (hasFetchedOnce) setIsFade(true); else setIsLoading(true);
        setError(null);
        setSelectedDateStr(date);

        const dataString = { date, cp_id: cpId };
        if (network_id) dataString.network_id = network_id;
        if (serviceId) dataString.serviceId = serviceId;

        try {
            const response = await fetch(API_ROUTES.HOURLY_CHART, {
                method: 'POST',
                body: objectToFormData(dataString),
                headers: { token: userData?.responseDetails?.token },
            });
            const responseJSON = await response.json();
            if (isAuthExpired(responseJSON)) return;

            if (responseJSON.status?.toString() === '200') {
                setHourlyRevenue(responseJSON.data?.hourly_revenue || []);
                setHourlyCount(responseJSON.data?.hourly_count || []);
            } else {
                setHourlyRevenue([]);
                setHourlyCount([]);
                setError(responseJSON.message || 'Unable to load hourly data.');
            }
        } catch (e) {
            console.log('Error getting hourly chart data:', e);
            setHourlyRevenue([]);
            setHourlyCount([]);
            setError('Network error — please try again.');
        } finally {
            setIsLoading(false);
            setIsFade(false);
            setHasFetchedOnce(true);
        }
    };

    useEffect(() => {
        fetchData({ date: todayYMD(), network_id: '', serviceId: '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Loaders />

            <div className="flapt-page-wrapper mainContent">
                <Menus />

                <div className="flapt-page-content">
                    <HeaderTop />

                    <div className="main-content introduction-farm mt--20">
                        <div className="content-wraper-area">
                            <div className="dashboard-area">
                                <div className="container-fluid mb-90">
                                    <div className="row g-4">
                                        <div className="col-lg-12 pl-xs-0 pr-xs-0">
                                            <div className="card-header mb--20 mb-xs-10">
                                                <h2>Hourly Revenue Report</h2>
                                            </div>

                                            <div className="App">
                                                <HourlyRevenueFilter
                                                    onSubmit={fetchData}
                                                    isLoading={isLoading || isFade}
                                                    isAuthExpired={isAuthExpired}
                                                />

                                                <HourlyRevenueCharts
                                                    isLoading={isLoading}
                                                    isFade={isFade}
                                                    hasFetchedOnce={hasFetchedOnce}
                                                    error={error}
                                                    hourlyRevenue={hourlyRevenue}
                                                    hourlyCount={hourlyCount}
                                                    selectedDateStr={selectedDateStr}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footers />
                    </div>
                </div>
            </div>
        </>
    );
}
